/**
 * SmartArt layout engine — pure, DOM-free. Dispatches to a per-family layout function and
 * returns percentage-based geometry that the editor and PPTX export both consume.
 *
 *   computeSmartArtLayout(layout, nodes, theme, variant)
 *     -> { boxes:    [{ nodeId, xPct, yPct, wPct, hPct, shapeType, fill, textColor }],
 *          connectors:[{ x1Pct, y1Pct, x2Pct, y2Pct, kind:'arrow'|'line', gapPct? }] }
 *
 * All coordinates are percentages (0–100) of the container box.
 */
import { normalizeNodes, DEFAULT_THEME } from '../smartArtUtils';
import { layoutList } from './list';
import { layoutProcess } from './process';
import { layoutCycle } from './cycle';
import { layoutHierarchy } from './hierarchy';
import { layoutPyramid } from './pyramid';

const ENGINES = {
  list: layoutList,
  process: layoutProcess,
  cycle: layoutCycle,
  hierarchy: layoutHierarchy,
  pyramid: layoutPyramid,
};

export const computeSmartArtLayout = (layout, nodes, theme = DEFAULT_THEME, variant) => {
  const engine = ENGINES[layout] || layoutList;
  const safeNodes = normalizeNodes(nodes || []);
  return engine(safeNodes, theme || DEFAULT_THEME, variant);
};

export default computeSmartArtLayout;
